var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIssuesError = function SvgIssuesError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD8A00",
    d: "M6.9.48L12 10.55a1 1 0 0 1-.9 1.45H.9a1 1 0 0 1-.9-1.45L5.1.48a1 1 0 0 1 1.8 0z",
    style: {
      fill: "#BD8A00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5 3h2v4H5z",
    style: {
      fill: "#FFF"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 1,
    fill: "#FFF"
  }))));
};
export default SvgIssuesError;